import React from 'react';
import clsx from 'clsx';
import { Box, Card, Stack, Typography } from '@curves/ui-base';
import { Overview } from '@curves/ui-shared';

import { parseDate } from '@Util/moment.util';
const headerRow = [
    {
        cellKey: 'creatorName',
        headerLabel: '建立者',
        align: 'center',
        style: { minWidth: 50 },
    },
    {
        cellKey: 'recordDate',
        headerLabel: '建立時間',
        align: 'center',
        style: { minWidth: 50 },
        formatCell: (value) => {
            return <React.Fragment>{parseDate(value)}</React.Fragment>;
        },
    },
    {
        cellKey: 'quantity',
        headerLabel: '數量',
        align: 'center',
        style: { minWidth: 50 },
        formatCell: (value) => {
            const isPositive = value > 0;
            return (
                <Box className={clsx(!(value === 0) && 'points-product-gift-record-quantity', isPositive ? 'blue' : 'red')}>{`${
                    isPositive ? '+' : ''
                }${value || '-'}`}</Box>
            );
        },
    },
    {
        cellKey: 'reason',
        headerLabel: '原因',
        align: 'center',
        width: 12,
        style: { minWidth: 50, maxWidth: '12rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        formatCell: (value) => {
            return (
                <Typography variant="h6" component="span" className={'white-space-normal'}>
                    {value}
                </Typography>
            );
        },
    },
];
const PointsProductGiftRecordTable = React.forwardRef((props, ref) => {
    const { sourceData = {}, pageIndex = 1, pageSize = 1, totalCount = 1, totalPage = 0, onPageChange } = props;
    const handlePageChange = (num) => {
        if (document.activeElement) document.activeElement.blur();
        onPageChange(num);
    };
    // 組出 Overview 所需的資料與換頁函式
    const contextValue = {
        overviewData: {
            list: sourceData,
            pagination: { pageIndex, pageSize, totalCount, totalPage: totalPage ?? 0 },
        },
        updateOverviewPage: handlePageChange,
    };
    return (
        <Card className="mt-4">
            <Card.CardContent className="p-3">
                <Overview contextValue={contextValue}>
                    <Stack className="overview__toolbar" alignItems="center" justifyContent="end">
                        <Typography variant="body2">{`(共${totalCount}筆)`}</Typography>
                    </Stack>
                    <Overview.Table headerRow={headerRow} cardProps={{ className: 'theme-gray' }} cellWidth={12} isFixed />
                </Overview>
            </Card.CardContent>
        </Card>
    );
});
export default PointsProductGiftRecordTable;
